import type { PrimitiveType } from '#layers/data-model/types/schema/primitive-type';
import { BuiltinBlockIds } from '#layers/data-model/constants/builtin-block-ids';
import {
	getTypename,
	getTypeParams,
	isPrimitiveTypeBoolean,
	isPrimitiveTypeNumber,
	isPrimitiveTypeUuid,
} from '#layers/data-model/utils/schema/primitive-type';

interface FieldPresentationBlock {
	block: string;
	props?: Record<string, unknown>;
}

export function getPrimitiveInputDefaults(type: PrimitiveType): FieldPresentationBlock {
	if (getTypename(type) === 'decimal') {
		const params = getTypeParams(type);

		return {
			block: BuiltinBlockIds.InputDecimalNumber,
			...(params ? { props: { ...params } as Record<string, unknown> } : {}),
		};
	}

	if (isPrimitiveTypeNumber(type)) {
		return {
			block: BuiltinBlockIds.InputNumber,
		};
	}

	if (isPrimitiveTypeBoolean(type)) {
		return {
			block: BuiltinBlockIds.InputSwitch,
		};
	}

	if (isPrimitiveTypeUuid(type)) {
		return {
			block: BuiltinBlockIds.InputUuid,
		};
	}

	return {
		block: BuiltinBlockIds.Input,
	};
}
